import { useFragment } from '@apollo/client';
import type { AccountOwnerFragment } from '@frameio/graphql-client/generated';
import { AccountOwner } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';

export function useAccountOwner(): AccountOwnerFragment | undefined {
  const accountId = useActiveAccountId() ?? '';
  const { complete, data } = useFragment<AccountOwnerFragment>({
    fragment: AccountOwner,
    fragmentName: 'AccountOwner',
    from: {
      __typename: 'Account',
      id: accountId,
    },
  });

  return complete ? data : undefined;
}
